import React from 'react';
import { Col, Row } from 'react-bootstrap';

/**
 * @component QuestionMedia
 * @description
 * Componente encargado de mostrar contenido multimedia relacionado con la pregunta:
 * una imagen y/o un archivo de audio. Solo se renderiza si al menos uno de los dos elementos está presente.
 *
 * El audio es protegido contra descarga mediante `controlsList="nodownload"` y la desactivación del clic derecho.
 *
 * @param {Object} props
 * @param {string} [props.image] - Nombre del archivo de imagen relacionado con la pregunta
 * @param {string} [props.audio] - Nombre del archivo de audio relacionado con la pregunta
 *
 * @returns {JSX.Element|null} Retorna un bloque de medios o `null` si no hay elementos
 *
 * @example
 * <QuestionMedia image="img1.png" audio="audio1" />
 */
const QuestionMedia = ({ image, audio }) => {
	if (!image && !audio) return null;

	return (
		<Row className="mt-2 justify-content-center">
			<Col xl={6} className="d-flex flex-column align-items-center">
				{image && (
					<img
						src={`${process.env.REACT_APP_CERTIFICATIONS_API}/files/download/epst/images/${image}`}
						alt="Imagen"
						className="img-fluid mb-2"
						style={{ maxHeight: '250px', objectFit: 'contain' }}
					/>
				)}
				{audio && (
					<audio
						controls
						controlsList="nodownload"
						className="w-100"
						onContextMenu={(e) => e.preventDefault()}
					>
						<source
							src={`${process.env.REACT_APP_CERTIFICATIONS_API}/files/download/epst/audios/${audio}.mp3`}
							type="audio/mpeg"
						/>
					</audio>
				)}
			</Col>
		</Row>
	);
};

export default QuestionMedia;